module.exports = __webpack_public_path__ + "static/media/certCCP.905b99ec.pdf";